import useAddRequestStore from 'store/addRequestStore';
import { classNames } from 'util/Funcs';
import AddRequestHeader from './AddRequestHeader';
import AmenitiesSelector from './AmentiesSelect';
import BuyerProfileSelector from './BuyerProfileSelector';
import Dropdown from './DropDown';

interface AdditionalPreferences {
    isEditMode?: boolean;
}

export default function AdditionalPreferences({ isEditMode }: AdditionalPreferences) {
    const { requestData, clearErrors, errors, setRequestData } = useAddRequestStore();

    const rows = window.innerWidth >= 1024 && window.innerWidth <= 1280 ? 8 : 10;
    return (
        <>
            <AddRequestHeader title="Additional Preferences" description="Choose any amentities or features you'd like" />
            <div className="lg:space-y-6 space-y-4 mt-4 lg:mt-6">
                <ItemContainer
                    title="Amenities & View Preferences"
                    description="Choose specific amenities & view preferences you'd like included in the property. You can select multiple options, up to a maximum of 10"
                    children={
                        <>
                            <div className={`${isEditMode ? 'w-full' : 'default-lg:w-10/12 default-xl:w-5/12 default-md:w-2/3 default-sm:w-full'}`}>
                                <AmenitiesSelector />
                            </div>
                            {errors.amenities && <p className="text-red-500 text-sm !mt-2">{errors.amenities}</p>}
                        </>
                    }
                />

                <ItemContainer
                    title="Buyer Profile"
                    description="Select the type of buyer you are"
                    children={
                        <>
                            <div className={`${isEditMode ? 'w-full' : 'default-lg:w-10/12 default-xl:w-5/12 default-md:w-2/3 default-sm:w-full'}`}>
                                <BuyerProfileSelector />
                            </div>
                            {errors.buyerProfile && <p className="text-red-500 text-sm !mt-2">{errors.buyerProfile}</p>}
                        </>
                    }
                />

                {requestData.propertyType !== 'Land' && requestData.propertyType !== 'Plot' && (
                    <ItemContainer
                        title="Furnishing"
                        description="Select the furnishing level that best suits your needs"
                        children={
                            <>
                                <div className={`${isEditMode ? 'w-full' : 'default-lg:w-10/12  default-md:w-2/3 default-sm:w-full'}`}>
                                    <Dropdown
                                        options={['Fully Furnished', 'Partially Furnished', 'Unfurnished', 'Furnished or Unfurnished']}
                                        isShown={false}
                                        heightClass="h-12"
                                        isEditMode={isEditMode}
                                        value={requestData.furnishing}
                                        onChange={(value) => {
                                            clearErrors('furnishing');
                                            setRequestData({ furnishing: value as string });
                                        }}
                                        showClearButton={false}
                                    />
                                    {errors.furnishing && <p className="text-red-500 text-sm !mt-2">{errors.furnishing}</p>}
                                </div>
                            </>
                        }
                        showBorder={false}
                    />
                )}
                <ItemContainer
                    title="Other Specific Requirements"
                    description="Use this space to list any unique preferences or requirements that are'nt covered in the previous sections"
                    children={
                        <>
                            <textarea
                                id="description"
                                rows={rows}
                                placeholder="e.g. Must have a south-facing balcony, close to public transport, eco-friendly"
                                className={classNames(
                                    isEditMode ? 'w-full' : 'default-lg:w-10/12 default-xl:w-5/12 default-md:w-2/3 w-full',
                                    'px-3 py-2 bg-gray-50 border border-gray-200 rounded-md text-lg outline-none',
                                    errors.otherSpecificRequirements && 'border-red-500',
                                )}
                                value={requestData.otherSpecificRequirements}
                                onChange={(e) => {
                                    clearErrors('otherSpecificRequirements');
                                    setRequestData({ otherSpecificRequirements: e.target.value });
                                }}
                            />
                            {errors.otherSpecificRequirements && <p className="text-red-500 text-sm">{errors.otherSpecificRequirements}</p>}
                        </>
                    }
                    showBorder={false}
                />
            </div>
        </>
    );
}

interface Props {
    title: string;
    description: string;
    children?: React.ReactNode;
    showBorder?: boolean;
}

function ItemContainer({ title, description, children, showBorder = true }: Props) {
    return (
        <>
            <div className="space-y-2 lg:space-y-3">
                <label htmlFor="title" className="block text-base  font-semibold text-light-black">
                    {title}
                </label>
                <p className="text-[12px]  text-light-black/80 mb-2">{description}</p>
                {children}
            </div>
            {showBorder && <div className="border border-gray-100  w-full " />}
        </>
    );
}
